﻿import { FilterGroupType } from '../types/filter-group';
import { FilterGroup } from '@fe/core';
import { useAppSelector } from '../app/hooks/store-hooks';

export default function useAllFilterGroups(): Record<FilterGroupType, FilterGroup[]> {
    return useAppSelector((x) => x.filterGroups.groups);
}
